import AdminShareEdit from "../../components/admin/admin-projects/AdminShareEdit";
import AdminTemplate from "../../views/AdminTemplate";

const AdminShareEditPage = () => {
  return (
    <AdminTemplate>
      <AdminShareEdit />
    </AdminTemplate>
  );
};

export default AdminShareEditPage;
